export default __webpack_public_path__ + "static/media/devguide04.08547150.md";